export default {
  'modelscope.cli.tab': 'Quick Use'
};
